export default __webpack_public_path__ + "static/media/9.7e2235f8.svg";